export default function LogoIcon() {
  return (
    <img src="/logo/icons.png" alt="OYN" className="h-full w-full object-contain" />
  );
}
